import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProductType} from "../../../Models/CustomerProductItem/ProductType";
import {MatTableDataSource} from "@angular/material/table";
import {ProductTypeChargerRelationDTO} from "../../../Ope/ProductType/ProductTypeChargerRelationDTO";
import {BaseDetailComponent} from "../../common/BaseDetailComponent";

@Component({
selector: 'app-product-type-detail',
templateUrl: './productTypeDetail.component.html',
styleUrls: ['./productTypeDetail.component.css']
})
export class ProductTypeDetailComponent extends BaseDetailComponent implements OnInit {
    ngOnInit(): void {

    }

    @Input('expandedElement') expandedElement?: ProductType;
    @Input('editMode') editMode?: boolean;
    @Output() refresh = new EventEmitter(this.selectedRow);
    @Output() validForm = new EventEmitter<boolean>();
    displayedColumns: string[] = ['name', 'power', 'taIndex', 'count'];
    tableDataSource!: MatTableDataSource<ProductTypeChargerRelationDTO>;

    getConnectorClass(element: ProductTypeChargerRelationDTO): string {
        return element.chargerCount > 0? "connectorInstalled" : "connectorNotInstalled"
    }
    ngOnChanges(): void {
        if(!!this.expandedElement?.chargers){
            this.tableDataSource = new MatTableDataSource<ProductTypeChargerRelationDTO>(this.expandedElement?.chargers);
        } else {
            this.tableDataSource = new MatTableDataSource<ProductTypeChargerRelationDTO>();
        }
    }

}
